type RelayModel = { id: string; provider?: string };

function normalizeRelayProvider(provider: string | undefined): string {
  const normalized = provider?.toLowerCase() ?? '';
  return normalized === 'boclaw' ? 'bocoder' : normalized;
}

export function relayProviderLabel(provider: string): string {
  return normalizeRelayProvider(provider) === 'bocoder' ? 'BoMate' : provider;
}

export function relayModelKey(model: RelayModel): string {
  if (!model.provider) return model.id;
  const provider = normalizeRelayProvider(model.provider) === 'bocoder'
    ? 'Bocoder'
    : model.provider;
  return `${provider}/${model.id}`;
}

export function findRelayModel<M extends RelayModel>(models: readonly M[], key: string | null | undefined): M | undefined {
  if (!key) return undefined;
  const exactId = models.find((model) => model.id === key);
  if (exactId) return exactId;
  const slash = key.indexOf('/');
  if (slash < 1) return undefined;
  const provider = normalizeRelayProvider(key.slice(0, slash));
  const id = key.slice(slash + 1);
  return models.find((model) => model.id === id && normalizeRelayProvider(model.provider) === provider);
}
